// extracted by mini-css-extract-plugin
export default {"landingMain":"LandingPage_landingMain__rjy9c"};